import { toUpperCaseAndSpacelessValue } from '../BuildingFormAdditionalFields.utils'

export function getNextValue(event) {
  const nextEvent = { ...event }

  nextEvent.target.value = toUpperCaseAndSpacelessValue(event.target.value)

  return nextEvent
}
